module.exports = __webpack_public_path__ + "img/Logo_pilsa_1.4e867dbb.png";